<template>
    <div class="wisdom-smart-warehouse-container">
        <div class="wisdom-smart-warehouse__banner">
            <div class="banner__content">
                <div class="banner__title">智慧无人仓</div>
                <div class="banner__info">提高企业、单位仓储建设智能化水平，优化仓储管理流程，提高物资利用效率，规范物资存放调用。利用数字化管控手段，规范物资全过程全生命周期管理，盘活闲置物资、降本降耗、提质增效。</div>
            </div>
        </div>
        <div class="policy-background-container">
            <div class="module__title">政策背景</div>
            <div class="module__info">
                <div>
                    国家电网公司［2014］748号文件正式颁布实施《国家电网电力安全工器具管理规定》。该规定中表明安全工器具领用、归还应严格履行交接和登记手续；安全工器具的保管及存放必须满足国家和行业标准及产品说明书要求；安全工器具宜根据产品要求存放于合适的温度、适度及通风条件处，与其他物资材料、设备设施应分开存放。
                </div>
                <div>
                    2015年12月1日中中华人民共和国电力行标准 DL/T1475-2015《电力安全工器具配置与存放技术要求》经国家能源局正式发布实施。国家能源局于2018年12月25日正式发布电力行业标准DL/T974-2018《带电作业用工具库房》。
                </div>
                <!-- <div>国家能源局于2018年12月25日正式发布电力行业标准DL/T974-2018《带电作业用工具库房》。</div> -->
            </div>
            <div class="policy-background__lists">
                <div class="policy-background__list" v-for="item in policyBackgroundLists" :key="item.id" v-lazy-container="{ selector: 'img' }">
                    <img :data-src="item.image" alt="" class="list__img">
                    <div class="list__title">{{item.title}}</div>
                    <div class="list__info">{{item.info}}</div>
                </div>
            </div>
        </div>
        <div class="construction-objectives-container">
            <div class="module__title">建设目标</div>
            <div class="module__info">
                设备专业仓管理系统是以物联网、大数据、人工智能、数字孪生、互联网技术为支撑，将设备仓储管理、设备标签管理、设备入库、领用、出库、盘点、调拨、转仓、报废等全生命周期管理、仓室环境管理、仓室安全防范管理等多种功能集中于一体的管理系统。
            </div>
            <div class="construction-objectives__lists">
                <div class="construction-objectives__list" v-for="item in constructionObjectivesLists" :key="item.id" v-lazy-container="{ selector: 'img' }">
                    <img :data-src="item.image" alt="" class="list__image">
                    <div class="list__detail">
                        <div class="detail__title">{{item.title}}</div>
                        <div class="detail__info">{{item.info}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="system-framework-container">
            <div class="module__title">系统框架</div>
            <img v-lazy="require('../assets/system-framework.png')" alt="" class="system-framework__image">
        </div>
    </div>
</template>

<script>
export default {
    name: 'wisdomSmartWarehouse',
    data() {
        return {
            policyBackgroundLists: [
                {
                    id: 1,
                    image: require("../assets/policy-background-list-1.png"),
                    title: '购存双高',
                    info: '设备库存富裕却仍旧增加采购计划，各类资产成本居高不下。'
                },
                {
                    id: 2,
                    image: require("../assets/policy-background-list-2.png"),
                    title: '账物不符',
                    info: '实物与价值、汇总与明细难以核准匹配'
                },
                {
                    id: 3,
                    image: require("../assets/policy-background-list-3.png"),
                    title: '效率低下',
                    info: '不同部门统计数据存在差异，盘点工作效率低'
                },
            ],
            constructionObjectivesLists: [
                {
                    id: 1,
                    image: require("../assets/construction-objectives-list-1.png"),
                    title: '保证设备帐、卡、物一致，台账准确可视化',
                    info: '将RFID电子标签与实体设备进行关联管理，针对现实仓室建设虚拟仓室，实现协同管理，实现设备出入库及库存信息的可视化、智能化。'
                },
                {
                    id: 2,
                    image: require("../assets/construction-objectives-list-2.png"),
                    title: '全程自动化管理，极大减少工作量，提高30%效率',
                    info: '设备全生命周期管理信息化、线上化；摆脱以往手工书写领用单、调拨单等落后方式；自动记录设备出入库，全面提升效率。'
                },
                {
                    id: 3,
                    image: require("../assets/construction-objectives-list-3.png"),
                    title: '仓库环境智能监测，保护设备轻松无忧',
                    info: '实现环境数据的实时采集和可视化展示，对环境异常情况进行主动预警，并远程控制设施进行自动调节。'
                },
                {
                    id: 4,
                    image: require("../assets/construction-objectives-list-4.png"),
                    title: '24小时视频监控，提供健全的设备安全保障体系',
                    info: '仓室管理员角色多重验证，并将操作与视频监控、门禁设施等状态联动，实现设备绝对安全。'
                },
            ]
        }
    }
}
</script>

<style scoped>
.wisdom-smart-warehouse-container .wisdom-smart-warehouse__banner {
    width: 100%;
    height: 400px;
    background: url("../assets/wisdom-smart-warehouse_banner.jpg") no-repeat center;
    background-size: 100% 100%;
}
.wisdom-smart-warehouse-container .wisdom-smart-warehouse__banner .banner__content {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
}
.wisdom-smart-warehouse-container .wisdom-smart-warehouse__banner .banner__content .banner__title {
    margin-bottom: 26px;
    font-size: 60px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 60px;
}
.wisdom-smart-warehouse-container .wisdom-smart-warehouse__banner .banner__content .banner__info {
    width: 53%;
    text-align: center;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #ffffff;
    line-height: 24px;
}
.wisdom-smart-warehouse-container .policy-background-container {
    margin-top: 106px;
}
.wisdom-smart-warehouse-container .policy-background-container .policy-background__lists {
    display: flex;
    justify-content: space-between;
    margin: 33px auto 0;
    width: 100%;
    max-width: 1180px;
}
.wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list {
    flex: 1 1 auto;
    margin-right: 20px;
}
.wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list:last-child {
    margin-right: 0;
}
.wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list .list__img {
    display: block;
    width: 100%;
    height: auto;
}
.wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list .list__title {
    margin-top: 11px;
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #404040;
    line-height: 19px;
}
.wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list .list__info {
    margin-top: 11px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #404040;
    line-height: 18px;
}
.wisdom-smart-warehouse-container .construction-objectives-container {
    margin-top: 106px;
}
.wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists {
    display: flex;
    flex-wrap: wrap;
    margin: 40px auto 0;
    width: 100%;
    max-width: 1196px;
}
.wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list {
    display: flex;
    align-items: center;
    margin-bottom: 17px;
    width: 50%;
}
.wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list .list__image {
    display: block;
    flex: 1 1 auto;
    margin-right: 35px;
    width: 46.8%;
    height: auto;
}
.wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list .list__detail {
    flex: 1 1 auto;
    padding-right: 40px;
}
.wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list .list__detail .detail__title {
    font-size: 16px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #333333;
    line-height: 19px;
}
.wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list .list__detail .detail__info {
    margin-top: 14px;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 19px;
}
.wisdom-smart-warehouse-container .system-framework-container {
    margin-top: 99px;
}
.wisdom-smart-warehouse-container .system-framework-container .system-framework__image {
    display: block;
    width: 100%;
    max-width: 1198px;
    height: auto;
    margin: 30px auto 116px;
}
.wisdom-smart-warehouse-container .module__title {
    text-align: center;
    font-size: 40px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #333333;
    line-height: 52px;
}
.wisdom-smart-warehouse-container .module__info {
    margin: 25px auto 0;
    width: 54%;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #404040;
    line-height: 20px;
    /* text-indent: 2em; */
}
@media screen and (max-width: 1200px) {
    .wisdom-smart-warehouse-container .module__info {
        width: 100%;
        padding: 0 40px;
    }
}
@media screen and (max-width: 576px) {
    .wisdom-smart-warehouse-container .policy-background-container .policy-background__lists {
        flex-direction: column;
    }
    .wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list {
        margin: 20px;
    }
    .wisdom-smart-warehouse-container .policy-background-container .policy-background__lists .policy-background__list:last-child {
        margin-right: 20px;
    }
}
@media screen and (max-width: 768px) {
    .wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists {
        flex-direction: column;
    }
    .wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list {
        width: 100%;
        padding: 0 40px;
    }
    .wisdom-smart-warehouse-container .construction-objectives-container .construction-objectives__lists .construction-objectives__list .list__detail {
        padding-right: 0;
    }
}
@media screen and (max-width: 576px) {
    .wisdom-smart-warehouse-container .system-framework-container .system-framework__image {
        margin-bottom: 58px;
    }
    .construction-objectives-container .construction-objectives__lists {
        flex-direction: column;
    }
    .construction-objectives-container .construction-objectives__lists .construction-objectives__list {
        width: 100%;
        padding: 0 15px;
    }
    .construction-objectives-container .construction-objectives__lists .construction-objectives__list .list__detail {
        padding-right: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/wisdomSmartWarehouse.vue